import { Component, Input, OnInit, Output, EventEmitter, ViewChild, TemplateRef, ChangeDetectorRef } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import _ from 'lodash';
import { ToastrService } from 'ngx-toastr';
import { UUID } from 'angular2-uuid';
import { FormBuilderUDFService } from 'src/app/services/form-builder-udf-service';
import { BaseApi } from 'src/backend/api/base-api';
import { GridApiRegistry } from '../list/grid-api-registry';

@Component({
  selector: 'app-list-property',
  templateUrl: './list-property.component.html',
  styleUrls: ['./list-property.component.scss']
})
export class ListPropertyComponent implements OnInit {

  /**
   * Auto-generate column field name from header name (no spaces/hyphens, max 100 chars)
   */
  dynamicInputRows: any[] = [];

  onColumnHeaderChange(header: string, idx: number) {
    const cleanField = header
      ? header.toLowerCase()
          .replace(/[^a-z0-9]+/g, '_')
          .replace(/^_+|_+$/g, '')
          .replace(/_+/g, '_')
          .substring(0, 100)
      : '';
    if (this.component.element.columnDefs && this.component.element.columnDefs[idx]) {
      this.component.element.columnDefs[idx].field = cleanField;
    }
  }

  @ViewChild('AgGridRowDataPoup') private AgGridRowDataPoup!: TemplateRef<any>;
  datasource: string;
  private _attributes: any;
  public varcharAttributes: Array<any> = [];
  @Input() component: any;
  jsonInput: string = '';
  errorMessage: string | null = null;
  cellEditorParamsValues: any;
  public gridOptions = {
    defaultColDef: {
      editable: true,
      resizable: true,
      sortable: true
    }
  };
  buttonEdit: boolean;
  buttonDelete: boolean;
  apiList: any;
  apiEndpoint: any;
  filteredAPIS: any;
  pageList!: any[];
  filteredPages: any[] = [];
  plantSession: any;

  // ── Add Data dialog state ──────────────────────────────────────────────────
  dialogColumns: any[] = [];
  dialogRows: any[] = [];
  dialogInitialRowCount: number = 1;

  @Input() set attributes(value: any) {
    this._attributes = value;
    if (this._attributes) {
      this.varcharAttributes = _.sortBy(
        this._attributes.filter((att: any) => att.type === 'varchar'),
        ['name']
      );
      if (this.component && this.component.element) {
        this.component.element.field_name = '';
      }
    }
  }

  get attributes(): any {
    return this._attributes;
  }

  @Output() onBindVariableChange: EventEmitter<any> = new EventEmitter();

  constructor(
    private dialog: MatDialog,
    private toaster: ToastrService,
    private formService: FormBuilderUDFService,
    private baseApi: BaseApi,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    // this.component.element.columnDefs = [];  i have commented because onload page list being disapear
    // this.component.element.rowData = [];
    this.plantSession = this.baseApi.getPlantFromStorage();
    this.getPages();
    this.getAPIList();
  }

  onChangeDatasourcetype(selected: any) {
    this.datasource = selected.value;
    if (this.datasource === 'url') {
      this.getAPIList();
    }
  }

  onChangeAPI(apiId: any) {
    const APIDetails = this.apiList.find((api: any) => api.id === apiId);
    if (APIDetails) {
      this.component.element.requestType = APIDetails.APIRequestType;
      this.component.element.datasourceUrl = APIDetails.APIURL;
      this.component.element.datasourceParamaters = APIDetails.APIPayloadParameter;
      this.component.element.resultsetName = APIDetails.APIResponseResultSetName;
    }
  }

  onChangeListType(selected: any) {
    this.component.element.listtype = selected.value;
    if (this.component.element.listtype === 'reportlist') {
      this.getPages();
    }
  }

  addColumns() {
    this.component.element.columnDefs.push({
      id: UUID.UUID(),
      headerName: '',
      field: '',
      editable: false,
      sortable: false,
      resizable: false,
      cellEditor: '',
      cellEditorSelect: false,
      cellEditorCheckbox: false,
      cellEditorParamsValues: '',
      cellRenderer: '',
      cellEditorParams: {},
    });
  }

  /**
   * Build a real checkbox renderer function.
   * Returns an ICellRenderer-compatible class so AG Grid manages
   * the lifecycle (init / getGui / refresh) properly — no string
   * name lookup, no registry, no 'relevance' crash.
   */
  private buildCheckboxRenderer() {
    // Return a class (not an instance) — AG Grid calls `new` on it internally
    return class CheckboxRenderer {
      private eGui!: HTMLElement;
      private eCheckbox!: HTMLInputElement;
      private params: any;

      init(params: any) {
        this.params = params;

        this.eGui = document.createElement('div');
        this.eGui.style.display = 'flex';
        this.eGui.style.justifyContent = 'center';
        this.eGui.style.alignItems = 'center';
        this.eGui.style.height = '100%';
        this.eGui.style.width = '100%';

        this.eCheckbox = document.createElement('input');
        this.eCheckbox.type = 'checkbox';
        this.eCheckbox.style.cursor = 'pointer';
        this.eCheckbox.style.width = '16px';
        this.eCheckbox.style.height = '16px';
        this.eCheckbox.style.accentColor = '#1976d2';

        this.eCheckbox.checked = CheckboxRenderer.toBoolean(params.value);

        this.eCheckbox.addEventListener('change', () => {
          params.node.setDataValue(params.colDef.field, this.eCheckbox.checked);
        });

        this.eGui.appendChild(this.eCheckbox);
      }

      getGui() {
        return this.eGui;
      }

      // Called by AG Grid when the cell value changes (e.g. after applyTransaction)
      refresh(params: any) {
        this.params = params;
        this.eCheckbox.checked = CheckboxRenderer.toBoolean(params.value);
        return true; // true = renderer handled the refresh, no need to recreate
      }

      destroy() {
        // nothing to clean up
      }

      static toBoolean(value: any): boolean {
        if (typeof value === 'boolean') return value;
        if (typeof value === 'number')  return value === 1;
        if (typeof value === 'string')  return ['true', '1', 'yes'].includes(value.toLowerCase());
        return false;
      }
    };
  }

  addColDefs() {
    const conflictIdx = this.component.element.columnDefs.findIndex(
      (v: any) => v && v.cellEditorCheckbox && v.cellEditorSelect
    );
    if (conflictIdx !== -1) {
      this.toaster.warning(
        `Column "${this.component.element.columnDefs[conflictIdx].headerName || (conflictIdx + 1)}" cannot be both Dropdown and Checkbox. Please select only one.`
      );
      return;
    }

    // Build one shared renderer class for all checkbox columns this call
    const CheckboxRendererClass = this.buildCheckboxRenderer();

    this.component.element.columnDefs = this.component.element.columnDefs.map((v: any) => {
      if (!v) return v;

      // Enforce mutual exclusion
      if (v.cellEditorCheckbox) {
        v.cellEditorSelect = false;
        v.editable = false;
      }
      if (v.cellEditorSelect) {
        v.cellEditorCheckbox = false;
      }

      // ── Checkbox column ─────────────────────────────────────────────────
      // Assign the class DIRECTLY as cellRenderer — AG Grid accepts a class
      // implementing ICellRenderer. No string name = no registry lookup = no crash.
      if (v.cellEditorCheckbox) {
        return {
          ...v,
          editable: false,
          cellEditor: '',
          cellEditorParams: {},
          cellRenderer: CheckboxRendererClass,  // ← class reference, not a string
        };
      }

      // ── Dropdown column ──────────────────────────────────────────────────
      if (v.cellEditorSelect) {
        let values = this.cleanArray(v.cellEditorParamsValues || '').filter(Boolean);
        if (!values.length) { values = ['Option 1', 'Option 2']; }
        return {
          ...v,
          editable: true,
          cellEditor: 'agSelectCellEditor',
          cellEditorParams: { values },
          cellRenderer: null,
        };
      }

      // ── Editable text column ─────────────────────────────────────────────
      if (v.editable) {
        return {
          ...v,
          editable: true,
          cellEditor: 'agTextCellEditor',
          cellEditorParams: {},
          cellRenderer: null,
        };
      }

      // ── Read-only column ─────────────────────────────────────────────────
      const hasBtnEdit   = this.component.element.buttonEdit;
      const hasBtnDelete = this.component.element.buttonDelete;
      const cellRenderer = hasBtnEdit ? 'buttonEditRenderer'
                         : hasBtnDelete ? 'buttonDeleteRenderer'
                         : null;

      return {
        ...v,
        cellRenderer,
        cellEditor: '',
        cellEditorParams: {},
      };
    });

    this.refreshGrid();
  }

  cleanArray(str: string): string[] {
    return str.split(',').map((item: string) => item.trim());
  }

  removeColumns(index: number) {
    this.component.element.columnDefs = this.component.element.columnDefs.filter(
      (_: any, idx: number) => idx !== index
    );
  }

  // ── Add Data dialog ────────────────────────────────────────────────────────

 openAGGridDataModel() {
  const cols = (this.component.element.columnDefs || []).filter(
    (c: any) => c.field && c.field !== '__delete' && c.field !== '__edit'
  );

  if (!cols.length) {
    this.toaster.warning('Please add and apply column definitions first.');
    return;
  }

  this.dialogColumns = cols;
  this.dialogInitialRowCount = 1;

  // Load existing rowData if available, otherwise start with one empty row
  const existing = this.component.element.rowData;
  if (existing && existing.length > 0) {
    // Deep clone so edits in dialog don't mutate live grid data until user clicks "Add to Grid"
    this.dialogRows = existing.map((r: any) => ({ ...r }));
  } else {
    this.dialogRows = [this.buildEmptyDialogRow()];
  }

  this.dialog.open(this.AgGridRowDataPoup, {
    minWidth: '65%',
    maxHeight: '90vh',
  }).afterClosed().subscribe(() => {
    this.dialogColumns = [];
    this.dialogRows = [];
    this.dialogInitialRowCount = 1;
  });
}

  buildEmptyDialogRow(): any {
    const row: any = {};
    for (const col of this.dialogColumns) {
      row[col.field] = col.cellEditorCheckbox ? false : '';
    }
    return row;
  }

  addDialogRow() {
    this.dialogRows = [...this.dialogRows, this.buildEmptyDialogRow()];
  }

  removeDialogRow(index: number) {
    this.dialogRows = this.dialogRows.filter((_, i) => i !== index);
  }

  generateDialogRows() {
    const count = Number(this.dialogInitialRowCount) || 0;
    if (count <= 0) {
      this.toaster.info('Please enter a valid number of rows (> 0)');
      return;
    }
    const generated: any[] = [];
    for (let i = 0; i < count; i++) {
      generated.push(this.buildEmptyDialogRow());
    }
    this.dialogRows = [...this.dialogRows, ...generated];
  }

  parseDropdownValues(str: string): string[] {
    if (!str || !str.trim()) return [];
    return str.split(',').map((s: string) => s.trim()).filter(Boolean);
  }

  saveDialogRows() {
    if (!this.dialogRows.length) {
      this.toaster.info('No rows to add. Please add at least one row.');
      return;
    }

    // OVERRIDE: replace all existing rowData with new rows — not append
    const newRows = this.dialogRows.map((r: any) => ({ ...r }));
    this.component.element.rowData = newRows;
    const count = newRows.length;

    this.dialog.closeAll();

    setTimeout(() => {
      this.replaceGridRows(newRows);
      this.toaster.success(`Grid updated with ${count} row(s) successfully`);
    }, 0);
  }

  // Full replace — clears all existing grid rows and sets the new ones
  private replaceGridRows(newRows: any[]) {
    const api = this.getGridApi();
    if (!api) {
      this.cdr.detectChanges();
      return;
    }
    setTimeout(() => {
      try {
        if (typeof api.setRowData === 'function') {
          api.setRowData(newRows);
        }
        if (typeof api.refreshCells === 'function') {
          api.refreshCells({ force: true });
        }
      } catch (e) {
        this.cdr.detectChanges();
      }
    }, 0);
  }

  private pushToGrid(newRows: any[]) {
    const api = this.getGridApi();
    if (!api) {
      this.cdr.detectChanges();
      return;
    }
    setTimeout(() => {
      try {
        if (typeof api.applyTransaction === 'function') {
          api.applyTransaction({ add: newRows });
        } else if (typeof api.setRowData === 'function') {
          api.setRowData(this.component.element.rowData);
        }
      } catch (e) {
        this.cdr.detectChanges();
      }
    }, 0);
  }

  private getGridApi(): any {
  return GridApiRegistry.get(this.component?.id) ?? null;
}

  refreshGrid() {
    const api = this.getGridApi();
    if (!api) {
      this.cdr.detectChanges();
      return;
    }
    setTimeout(() => {
      try {
        if (typeof api.setColumnDefs === 'function') {
          api.setColumnDefs(this.component.element.columnDefs);
        }
        if (typeof api.setRowData === 'function') {
          api.setRowData(this.component.element.rowData || []);
        }
        if (typeof api.refreshCells === 'function') {
          api.refreshCells({ force: true });
        }
      } catch (e) {
        this.cdr.detectChanges();
      }
    }, 0);
  }

  // ── Legacy kept for backward compatibility ─────────────────────────────────

  addData() {
    try {
      const parsed = JSON.parse(this.jsonInput.trim());
      const jsonData = Array.isArray(parsed) ? parsed : [parsed];
      this.processJsonData(jsonData);
    } catch {
      this.toaster.error('Invalid JSON format. Please use valid JSON array, e.g. [{"field1":"value"}]');
    }
  }

  processJsonData(data: any[]) {
    const cols: any[] = this.component.element.columnDefs || [];
    const validFields = cols
      .map((c: any) => c.field)
      .filter((f: string) => f && f !== '__delete' && f !== '__edit');

    const matchedData = data.filter((item: any) =>
      validFields.every((field: string) => field in item)
    );

    if (matchedData.length > 0) {
      if (!Array.isArray(this.component.element.rowData)) {
        this.component.element.rowData = [];
      }
      this.component.element.rowData = [...this.component.element.rowData, ...matchedData];
      this.errorMessage = null;
      setTimeout(() => this.pushToGrid(matchedData), 0);
    } else {
      this.errorMessage = 'JSON data does not match the column definitions.';
      this.toaster.error(this.errorMessage);
    }
  }

  parseAndMatchData(data: any[]) {
    return data.filter((item: any) =>
      this.component.element.columnDefs.every((colDef: any) => colDef.field in item)
    );
  }

  handleOnBindVariableChange($event: any) {
    this.onBindVariableChange.emit({ value: $event, id: this.component.id });
  }

  getAPIList() {
    this.formService.getAPIList().subscribe({
      next: (data: any) => {
        if (data) {
          this.apiList = data.Table;
          this.filteredAPIS = this.apiList.slice();
        }
      },
      error: () => {
        this.toaster.error('Error fetching API list');
      }
    });
  }

  getPages(): void {
    this.formService.getFormsTable().subscribe(
      (data: any) => {
        this.pageList = data.Table;
        this.filteredPages = this.pageList.slice();
      },
      (error: any) => {
        this.toaster.error('error', error.message);
      }
    );
  }

  generateRows(): void {
    const rowCount = this.component.element.initialRowCount || 0;
    if (rowCount <= 0) {
      this.toaster.info('Please enter a valid number of rows');
      return;
    }
    const cols = this.component.element.columnDefs || [];
    if (cols.length === 0) {
      this.toaster.warning('Please add columns first');
      return;
    }
    const rows: any[] = [];
    for (let i = 0; i < rowCount; i++) {
      const row: any = {};
      for (const column of cols) {
        if (column.field && column.field !== '__delete' && column.field !== '__edit') {
          row[column.field] = column.cellEditorCheckbox ? false : '';
        }
      }
      rows.push(row);
    }
    this.component.element.rowData = rows;
    this.toaster.success(`${rowCount} rows generated successfully`);
    setTimeout(() => this.refreshGrid(), 0);
  }

  onLabelChange(label: string) {
    this.component.element.field_name = label
      ? label.toLowerCase()
          .replace(/[^a-z0-9]+/g, '_')
          .replace(/^_+|_+$/g, '')
          .replace(/_+/g, '_')
          .substring(0, 100)
      : '';
  }
    // Remove forbidden special characters from field_name (SQL Server safe)
  sanitizeFieldName() {
    if (this.component && this.component.element && typeof this.component.element.field_name === 'string') {
      // Only allow letters, numbers, and underscores, must start with letter or underscore
      let val = this.component.element.field_name;
      // Remove forbidden special characters ($&^#@ and others)
      val = val.replace(/[^A-Za-z0-9_]/g, '');
      // Ensure first character is letter or underscore
      if (!/^[A-Za-z_]/.test(val)) {
        val = val.replace(/^[^A-Za-z_]+/, '');
      }
      // Limit to 100 chars
      this.component.element.field_name = val.substring(0, 100);
    }
  }

    // Prevent forbidden special characters from being entered
  preventSpecialChar(event: KeyboardEvent) {
    const allowed = /^[A-Za-z0-9_]$/;
    // Allow navigation, backspace, delete, tab, arrows, home, end
    if (
      event.ctrlKey || event.metaKey ||
      [8, 9, 13, 16, 17, 18, 20, 27, 35, 36, 37, 38, 39, 40, 46].includes(event.keyCode)
    ) {
      return;
    }
    if (!allowed.test(event.key)) {
      event.preventDefault();
    }
  }

  // Filter forbidden characters on paste or input
  filterSpecialCharOnInput() {
    if (this.component && this.component.element && typeof this.component.element.field_name === 'string') {
      let val = this.component.element.field_name;
      val = val.replace(/[^A-Za-z0-9_]/g, '');
      // Ensure first character is letter or underscore
      if (!/^[A-Za-z_]/.test(val)) {
        val = val.replace(/^[^A-Za-z_]+/, '');
      }
      this.component.element.field_name = val.substring(0, 100);
    }
  }
}